<template>
  <div>
    <ContentHeader :title="'Bank Account'">
      <router-link 
        v-if="filteredBanks.length < 1 && !loading"
        :to="{ name: 'AddBank' }"
        class="btn btn-success rounded-pill mx-3"
        ><i class="fas fa-plus"></i> <span class="px-2">Add</span></router-link
      >
    </ContentHeader>
    <section class="content">
      <div class="container-fluid">
        <div v-if="filteredBanks.length > 0 && !loading" class="alert alert-danger" role="alert">
          If you want to edit and delete a bank account, please contact the admin immediately
        </div>
        <div v-if="loading" class="d-flex bank-account-container px-md-3">
          <bank-card skeleton></bank-card>
        </div>
        <div v-else v-dragscroll class="d-flex bank-account-container px-md-3">
          <bank-card
            v-for="bank in filteredBanks"
            :key="bank.id"
            :bank="bank"
            :accountNumber="formatBankNumber(bank.account_number)"
            @deleteItem="deleteItem"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import BankCard from "@/components/molecules/BankCard.vue";
import apiVendor from "../../services/VendorApiServices";
import { dragscroll } from "vue-dragscroll";

export default {
  directives: {
    dragscroll,
  },
  data() {
    return {
      loading: true,
      banks: [],
    };
  },
  components: {
    ContentHeader,
    BankCard,
  },
  computed: {
    filteredBanks() {
      return this.banks.filter((item) => !item.deleted_at);
    },
  },
  async mounted() {
    try {
      let bankList = await apiVendor.get(`bank/?vendor_robot=${this.$user_id}`);
      this.banks = bankList.data.data;
    } catch (error) {
      this.$toasted.show(error.message, {
        theme: "toasted-primary",
        position: "top-right",
        duration: 4000,
      });
    } finally {
      this.loading = false
    }
  },
  methods: {
    formatBankNumber(value) {
      let number = value.toString().match(/.{1,4}/g)
      return number.join(' ')
    },
    deleteItem(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await apiVendor.delete(`bank/${id}/`);
            this.banks = this.banks.filter((item) => item.id != id);
          } catch (error) {
            this.$toasted.show(error.message, {
              theme: "toasted-primary",
              position: "top-right",
              duration: 4000,
            });
          }
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
  },
};
</script>

<style scoped>
.bank-account-container {
  overflow-x: scroll;
}
@media (min-width: 319px) {
}

@media (min-width: 374px) {
  .bank-account-container {
    overflow-x: scroll;
  }
}

@media (min-width: 424px) {
  .bank-account-container {
    overflow-x: hidden;
  }
}

@media (min-width: 767px) {
}

@media (min-width: 1023px) {
}

@media (min-width: 1439px) {
}

@media (min-width: 2000px) {
}
</style>